import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn } from "lucide-react";

export default function PortalHomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center"
      >
        {/* Title - same styling as "Guest Submissions" heading but larger and uppercase */}
        <h1 className="text-2xl md:text-3xl font-medium text-foreground uppercase tracking-wide mb-16">
          My Concierge Portal
        </h1>

        {/* Log in Button */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          onClick={() => navigate("/login")}
          data-testid="agent-login-btn"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground text-white font-medium rounded-full hover:bg-foreground/90 transition-colors"
        >
          <LogIn className="w-5 h-5" />
          Log in
        </motion.button>
      </motion.div>
    </div>
  );
}
